import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const SERVICES = ['Reseñas', 'Reels', 'Stories', 'Contenido web', 'Entrevistas', 'Lanzamientos', 'Eventos', 'Campañas integradas', 'Contenido personalizado'];

const PACKS = [
  { name: 'Pack Lectura', description: 'Reseña web.' },
  { name: 'Pack Social', description: 'Reel + Stories.' },
  { name: 'Pack Editorial', description: 'Reseña + Reel + Stories.' },
  { name: 'Pack Lanzamiento', description: 'Combinación ampliada para lanzamientos.' }
];

function TrabajaConmigo() {
  return (
    <div className="page professional-page">
      <Seo title="Trabaja conmigo" description="Colaboraciones con editoriales, escritores, agencias y marcas: reseñas, reels, stories y contenido personalizado." />
      <header className="professional-hero">
        <span className="eyebrow">Colaboraciones</span>
        <h1>Historias que encuentran a sus lectores</h1>
        <p>
          Libros para Viajeros combina lectura, recomendaciones, reseñas, cultura y viajes literarios. Trabajo con
          editoriales, escritores, agencias y marcas para dar visibilidad a sus libros y proyectos.
        </p>
        <Link className="cta-button" to="/contacto">Solicitar propuesta</Link>
      </header>

      <section className="professional-section" aria-labelledby="servicios-title">
        <div className="professional-section__heading">
          <span className="eyebrow">Qué puedo crear</span>
          <h2 id="servicios-title">Servicios</h2>
        </div>
        <ul className="service-list">
          {SERVICES.map((service) => <li key={service}>{service}</li>)}
        </ul>
      </section>

      <section className="professional-section" aria-labelledby="modalidades-title">
        <div className="professional-section__heading">
          <span className="eyebrow">Propuestas flexibles</span>
          <h2 id="modalidades-title">Modalidades</h2>
        </div>
        <div className="pack-grid">
          {PACKS.map((pack, index) => (
            <article key={pack.name} className="pack-card">
              <span className="pack-card__number" aria-hidden="true">0{index + 1}</span>
              <h3>{pack.name}</h3>
              <p>{pack.description}</p>
            </article>
          ))}
        </div>
      </section>

      <aside className="editorial-policy">
        <span className="eyebrow">Independencia editorial</span>
        <p>
          Una colaboración remunera el tiempo, la lectura, el análisis, la producción y la difusión del contenido.
          Nunca garantiza una valoración positiva.
        </p>
      </aside>

      <footer className="professional-footer">
        <p>¿Tienes un libro o un proyecto que quieras dar a conocer?</p>
        <div className="professional-footer__actions">
          <Link className="cta-button" to="/contacto">Hablemos</Link>
          <Link className="text-link" to="/media-kit">Ver Media Kit</Link>
          <Link className="text-link" to="/colaboraciones">Ver colaboraciones</Link>
        </div>
      </footer>
    </div>
  );
}

export default TrabajaConmigo;
